/* ═══════════════════════════════════════════════════════════════
   BATCH 7: Storage Abstraction Layer
   Wraps localStorage for easy swap to AsyncStorage in React Native
   ═══════════════════════════════════════════════════════════════ */

const storage = {
  get: async (key) => {
    try {
      const value = localStorage.getItem(key);
      return value ? JSON.parse(value) : null;
    } catch (err) {
      console.error(`Storage get error for key "${key}":`, err);
      return null;
    }
  },

  set: async (key, value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (err) {
      console.error(`Storage set error for key "${key}":`, err);
    }
  },

  remove: async (key) => {
    try {
      localStorage.removeItem(key);
    } catch (err) {
      console.error(`Storage remove error for key "${key}":`, err);
    }
  },

  // Helper for non-JSON string values
  getString: async (key) => {
    try {
      return localStorage.getItem(key);
    } catch (err) {
      console.error(`Storage getString error for key "${key}":`, err);
      return null;
    }
  },

  setString: async (key, value) => {
    try {
      localStorage.setItem(key, value);
    } catch (err) {
      console.error(`Storage setString error for key "${key}":`, err);
    }
  },
};

export default storage;
